import type { ProfileEntity } from "building-types/entities/profileEntityTypes";
import { DEFAULT_PROFILE_DESCRIPTOR } from "building-types/profiles/defaultBoardTrimProfiles";
import { ProfileExtrusionType } from "building-types/profiles/profileTypesEnum";
import { boardProfileEntityNew } from "../../utils/profileTools";

const DEFAULT_PROFILE_ID: string = ProfileExtrusionType.DEFAULT_PROFILE;

export function isSystemDefaultProfile(id: string): boolean {
  return id === DEFAULT_PROFILE_ID;
}

export const defaultProfileEntity: ProfileEntity = boardProfileEntityNew({
  id: DEFAULT_PROFILE_ID,
  name: "Default Profile",
  width: DEFAULT_PROFILE_DESCRIPTOR.width,
  height: DEFAULT_PROFILE_DESCRIPTOR.height,
  nominalWidth: DEFAULT_PROFILE_DESCRIPTOR.nominalWidth,
  nominalHeight: DEFAULT_PROFILE_DESCRIPTOR.nominalHeight,
  elevationNoteEnabled: DEFAULT_PROFILE_DESCRIPTOR.elevationNoteEnabled,
  elevationNote: DEFAULT_PROFILE_DESCRIPTOR.elevationNote,
  sortIndex: 0,
});
